import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, loading, isAuthenticated, isAdmin, isApproved } = useAuth();
  const location = useLocation();

  // If user data was passed from AuthCallback, use it directly
  if (location.state?.user) {
    const userData = location.state.user;
    // For admin panel: allow admins OR approved users (with role-based menu filtering)
    if (requireAdmin && !userData.is_admin && !userData.is_approved) {
      return <Navigate to="/unauthorized" replace />;
    }
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin text-slate-600 mx-auto mb-4" />
          <p className="text-slate-600">Vérification de l'authentification...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // For admin panel: allow admins OR approved users (with role-based menu filtering)
  // Regular users with role='user' and is_approved=true can access with limited menus
  if (requireAdmin && !isAdmin && !isApproved) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
